export default "__VITE_ASSET__da4d4238__"